import services from '../../../services'

const state = {
}

const actions = {
  async carouselList ({commit}, query) {
    return await services.carousel_query(query)
  },
  async carouselDetail ({commit}, id) {
    return await services.carousel_get(id)
  },
  async carouselEdit ({commit}, options) {
    return await services.carousel_edit(options)
  }
}

const mutations = {
}
export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/system/carousel.js